import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ItemLossesBalanceParams } from '@data';
import { LossesBalanceItemComponent } from '../../molecules/losses/losses-balance-item.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    LossesBalanceItemComponent,
],
  selector: 'ui-losses-balance-chart',
  template: `
    <ng-container *transloco="let t">
      <div class="flex items-center justify-between">
        <div class="flex gap-3 text-right text-xs text-slate-500">
          <p class="flex items-center gap-2">
            <span class="bg-blue-500 rounded-full h-[16px] w-[16px] block"></span>
            {{ t('CHARTS.LOSSES.LEGEND_ENERGY') }}
          </p>
          <p class="flex items-center gap-2">
            <span class="bg-sky-200 rounded-full h-[16px] w-[16px] block"></span>
            {{ t('CHARTS.LOSSES.LEGEND_CT') }}
          </p>
        </div>
        <div>
          <p class="text-xs text-slate-500">
            {{ t(periodTime()) }}
          </p>
        </div>
      </div>
      <div>
        <div class="grid grid-cols-12 gap-x-3 min-h-[44px] items-center">
          <div class="col-span-1 col-start-4 text-center font-bold text-neutral-600">
            <span> {{ t('LOSSES.LABEL') }}</span>
          </div>
        </div>
      </div>
      <div class=" max-h-[377px] overflow-y-auto">
        @for (item of items(); track item) {
          <ui-losses-balance-item [item]="item" (onCenter)="emitLostCenter($event)" />
        }
      </div>
    </ng-container>
  `,
})
export class LossesBalanceChartComponent {
  items = input.required<ItemLossesBalanceParams[]>();
  todayDate = input.required<string>();
  periodTime = input<string>('');
  onCenter = output<{
    distributorId: string;
    centerId: string;
    rsabtId?: string;
    tsabtId?: string;
    vtnId?: string;
  }>();
  emitLostCenter(event: {
    distributorId: string;
    centerId: string;
    rsabtId?: string;
    tsabtId?: string;
    vtnId?: string;
  }) {
    this.onCenter.emit(event);
  }
}
